"use strict";
exports.__esModule = true;
function formatCurrency(cents, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.country, country = _c === void 0 ? 'US' : _c, _d = _b.includeUnits, includeUnits = _d === void 0 ? false : _d, _e = _b.showCents, showCents = _e === void 0 ? true : _e;
    var dollars = cents / 100;
    var formattedDollars;
    if (Number.isInteger(dollars) && !showCents) {
        formattedDollars = dollars.toFixed(0);
    }
    else {
        formattedDollars = dollars.toFixed(2);
    }
    if (includeUnits) {
        if (country === 'US') {
            formattedDollars = "$" + formattedDollars;
        }
        else if (country === 'CA') {
            formattedDollars = "$" + formattedDollars + " CAD";
        }
    }
    return formattedDollars;
}
exports.formatCurrency = formatCurrency;
